import { useEffect, useRef, useState } from "react";
import {
    Phone,
    MapPin,
    Check,
    Sparkles,
    ArrowUpRight,
    Clock,
    ShieldCheck,
    Droplets,
    Quote,
    Star,
    Play,
    Car,
    Navigation,
    Plug,
    CloudRain,
    MessageSquare,
    Info,
    Sofa,
    Ban,
    Mail,
    Calculator,
    Loader2,
    Search,
    Waves,
    Package,
    Instagram,
} from "lucide-react";

const PHONE_DISPLAY = "06 98 93 61 33";
const PHONE_LINK = "tel:+33698936133";
const EMAIL = "nettoyage980@gmail.com";
const EMAIL_LINK = "mailto:nettoyage980@gmail.com";
const SMS_LINK =
    "sms:+33698936133?body=Bonjour%2C%20je%20souhaite%20un%20devis%20%3A%20%0APrestation%20%3A%20(Int%C3%A9rieur%2050%E2%82%AC%20%2F%20Int%C3%A9rieur%20Complet%2055%E2%82%AC)%0AAdresse%20%3A%20";
const SMS_BOOKING =
    "sms:+33698936133?body=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20%E2%9C%A8%0A%0APrestation%20souhait%C3%A9e%20%28int%C3%A9rieur%20%2F%20ext%C3%A9rieur%20%2F%20int%C3%A9rieur%20complet%20%2F%20pack%20ultime%20%2F%20canap%C3%A9%29%20%3A%20%0AAdresse%20compl%C3%A8te%20%3A%20%0AMes%20disponibilit%C3%A9s%20%3A%20%0A%0AMerci%20%21";
const SMS_BOOKING_SOFA =
    "sms:+33698936133?body=Bonjour%2C%20je%20souhaite%20un%20nettoyage%20de%20tissu%20d%27ameublement%20%F0%9F%9B%8B%EF%B8%8F%0A%0AArticle(s)%20(chaise%2010%E2%82%AC%20%2F%20fauteuil%2020%E2%82%AC%20%2F%20canap%C3%A9%202%20places%2030%E2%82%AC%20%2F%20autre%20canap%C3%A9%2040%E2%82%AC)%20%3A%20%0AAdresse%20compl%C3%A8te%20%3A%20%0AMes%20disponibilit%C3%A9s%20%3A%20%0A%0AMerci%20%21";

// Discrete line illustrations for sofa items
const ChairDrawing = (props) => (
    <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M22 10v24M42 10v24" />
        <rect x="20" y="8" width="24" height="4" rx="1" />
        <path d="M18 34h28l-2 10H20z" />
        <path d="M22 44v10M42 44v10" />
    </svg>
);

const ArmchairDrawing = (props) => (
    <svg
        viewBox="0 0 64 64"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M12 42V26c0-3 2-5 5-5h30c3 0 5 2 5 5v16" />
        <rect x="12" y="38" width="40" height="12" rx="2" />
        <path d="M10 32v18M54 32v18" />
        <path d="M16 50v4M48 50v4" />
    </svg>
);

const Sofa2Drawing = (props) => (
    <svg
        viewBox="0 0 72 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M8 32V18c0-3 2-5 5-5h46c3 0 5 2 5 5v14" />
        <rect x="8" y="28" width="56" height="10" rx="2" />
        <path d="M6 24v14M66 24v14" />
        <path d="M36 15v16" />
        <path d="M14 38v4M58 38v4" />
    </svg>
);

const SofaLargeDrawing = (props) => (
    <svg
        viewBox="0 0 96 48"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M8 32V18c0-3 2-5 5-5h70c3 0 5 2 5 5v14" />
        <rect x="8" y="28" width="80" height="10" rx="2" />
        <path d="M6 24v14M90 24v14" />
        <path d="M34 15v16M62 15v16" />
        <path d="M14 38v4M82 38v4" />
    </svg>
);
const LOCATION = "Mantes-la-Jolie (78) & alentours";
const TIKTOK_HANDLE = "eclat_idf";
const TIKTOK_URL = "https://www.tiktok.com/@eclat_idf";
const INSTAGRAM_HANDLE = "eclat__pro";
const INSTAGRAM_URL = "https://www.instagram.com/eclat__pro/";

const Section = ({ children, id, className = "" }) => (
    <section id={id} className={`relative w-full ${className}`}>
        {children}
    </section>
);

const Nav = () => (
    <nav
        className="fixed top-0 left-0 right-0 z-50 px-6 md:px-12 py-6 flex items-center justify-between"
        data-testid="main-nav"
    >
        <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-white text-black grid place-items-center font-heading font-black text-lg">
                É
            </div>
            <div className="font-heading font-semibold tracking-tight text-sm md:text-base">
                ÉCLAT
            </div>
        </div>

        <div className="hidden md:flex items-center gap-7 text-sm text-white/70 font-body">
            <a
                href="#auto"
                className="hover:text-white transition-colors"
                data-testid="nav-auto"
            >
                Auto
            </a>
            <a
                href="#canape"
                className="hover:text-white transition-colors"
                data-testid="nav-canape"
            >
                Canapé
            </a>
            <a
                href="#deplacement"
                className="hover:text-white transition-colors"
                data-testid="nav-deplacement"
            >
                Déplacement
            </a>
            <a
                href="#infos"
                className="hover:text-white transition-colors"
                data-testid="nav-infos"
            >
                Infos
            </a>
            <a
                href="#avis"
                className="hover:text-white transition-colors"
                data-testid="nav-avis"
            >
                Avis
            </a>
            <a
                href="#contact"
                className="hover:text-white transition-colors"
                data-testid="nav-contact"
            >
                Contact
            </a>
        </div>

        <a
            href={PHONE_LINK}
            className="btn-tactile-ghost text-xs md:text-sm"
            data-testid="nav-phone-cta"
        >
            <Phone className="w-3.5 h-3.5" strokeWidth={2.2} />
            <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
            <span className="sm:hidden">Appeler</span>
        </a>
    </nav>
);

const Hero = () => (
    <Section id="hero" className="min-h-screen overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0">
            <img
                src="https://images.unsplash.com/photo-1688026238669-18cb83914a44?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBibGFjayUyMGNhciUyMHBvbGlzaGVkJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODA2NzQ5NjZ8MA&ixlib=rb-4.1.0&q=85"
                alt="Voiture noire polie premium"
                className="w-full h-full object-cover scale-105"
            />
            <div className="absolute inset-0 hero-vignette" />
        </div>

        {/* Top right meta */}
        <div className="absolute top-28 md:top-32 right-6 md:right-12 z-10 text-right hidden sm:block reveal delay-200">
            <div className="text-white/40 text-[10px] tracking-[0.25em] font-body uppercase mb-2">
                Service Premium
            </div>
            <div className="font-heading text-white text-sm tracking-tight">
                Mantes‑la‑Jolie · 78
            </div>
        </div>

        {/* Main hero content */}
        <div className="absolute inset-x-0 bottom-0 px-6 md:px-12 lg:px-20 pb-10 md:pb-16 z-10">
            <div className="max-w-7xl">
                {/* Location badge */}
                <div className="reveal flex items-center gap-3 mb-4 md:mb-5">
                    <span className="relative flex h-2.5 w-2.5">
                        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 pulse-dot" />
                        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-400" />
                    </span>
                    <span
                        className="text-white/80 text-xs md:text-sm font-body tracking-wide"
                        data-testid="hero-location-badge"
                    >
                        <MapPin className="inline w-3.5 h-3.5 mr-1.5 -mt-0.5" />
                        {LOCATION}
                    </span>
                </div>

                {/* Headline */}
                <h1
                    className="reveal delay-100 font-heading text-white text-shadow-strong text-[2.6rem] sm:text-5xl lg:text-6xl xl:text-7xl font-black leading-[0.95] mb-5 max-w-5xl"
                    data-testid="hero-title"
                >
                    L&apos;éclat de
                    <br />
                    vos intérieurs.
                    <span className="text-white/40"> Notre obsession.</span>
                </h1>

                {/* Subtitle */}
                <p
                    className="reveal delay-200 text-white/70 font-body text-sm md:text-lg max-w-2xl leading-relaxed mb-5"
                    data-testid="hero-subtitle"
                >
                    Nettoyage auto & shampouinage de canapés (tissu).
                    Matériel pro, résultat impeccable, tarifs transparents.
                </p>

                {/* Service chips */}
                <div className="reveal delay-200 flex flex-wrap gap-2 mb-8">
                    <a
                        href="#auto"
                        data-testid="hero-chip-auto"
                        className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/[0.06] border border-white/15 backdrop-blur-md text-white text-xs font-heading hover:bg-white/[0.12] transition-colors"
                    >
                        <Car className="w-3.5 h-3.5" strokeWidth={2} />
                        Auto · dès 50 €
                    </a>
                    <a
                        href="#canape"
                        data-testid="hero-chip-canape"
                        className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-white/[0.06] border border-white/15 backdrop-blur-md text-white text-xs font-heading hover:bg-white/[0.12] transition-colors"
                    >
                        <Sofa className="w-3.5 h-3.5" strokeWidth={2} />
                        Textile · dès 10 €
                    </a>
                </div>

                {/* CTAs */}
                <div className="reveal delay-300 flex flex-wrap items-center gap-4">
                    <a
                        href={PHONE_LINK}
                        className="btn-tactile group"
                        data-testid="hero-phone-cta"
                    >
                        <Phone className="w-4 h-4" strokeWidth={2.4} />
                        <span>Appeler le {PHONE_DISPLAY}</span>
                        <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </a>
                    <a
                        href="#formules"
                        className="btn-tactile-ghost"
                        data-testid="hero-formules-cta"
                    >
                        <Sparkles className="w-4 h-4" strokeWidth={2} />
                        <span className="font-heading">Voir les formules</span>
                    </a>
                </div>

                {/* Bottom info row */}
                <div className="reveal delay-400 mt-10 md:mt-12 grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8 max-w-4xl pt-6 border-t border-white/10">
                    {[
                        {
                            icon: ShieldCheck,
                            label: "Pro & soigné",
                            sub: "Matériel premium",
                        },
                        {
                            icon: Droplets,
                            label: "Shampouineuse",
                            sub: "Extraction profonde",
                        },
                        {
                            icon: Clock,
                            label: "7j/7 · 9h — 19h",
                            sub: "Sur rendez-vous",
                        },
                        {
                            icon: MapPin,
                            label: "Mantes (78)",
                            sub: "& alentours",
                        },
                    ].map((it) => (
                        <div key={it.label} className="flex items-start gap-3">
                            <it.icon
                                className="w-5 h-5 text-white/60 mt-0.5"
                                strokeWidth={1.5}
                            />
                            <div>
                                <div className="font-heading text-white text-sm">
                                    {it.label}
                                </div>
                                <div className="font-body text-white/40 text-xs mt-0.5">
                                    {it.sub}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </Section>
);

const Marquee = () => {
    const items = [
        "NETTOYAGE AUTO",
        "EXTÉRIEUR CARROSSERIE",
        "SHAMPOUINAGE CANAPÉ",
        "PACK ULTIME · 80 €",
        "ASPIRATION COMPLÈTE",
        "EXTRACTION PROFONDE",
        "TISSU & MICROFIBRE",
        "JANTES & VITRES",
    ];
    const row = [...items, ...items];
    return (
        <div
            className="relative border-y border-white/10 bg-[#0a0a0c] py-6 overflow-hidden"
            data-testid="marquee"
        >
            <div className="marquee-track gap-12 whitespace-nowrap">
                {row.map((t, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-12 font-heading text-xl md:text-3xl font-bold tracking-tight text-white/30"
                    >
                        <span>{t}</span>
                        <span className="text-white/15">✦</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

const PriceCard = ({
    index,
    title,
    price,
    badge,
    duration,
    features,
    highlight,
    featured,
    premium,
    ctaHref,
    ctaLabel,
    testId,
}) => (
    <div
        className={`relative rounded-2xl p-8 md:p-10 lg:p-12 transition-all ${
            premium
                ? "premium-card"
                : "crystal"
        }`}
        data-testid={testId}
    >
        {premium && (
            <>
                <div className="pointer-events-none absolute -inset-px rounded-2xl bg-gradient-to-br from-white/40 via-white/10 to-white/40 opacity-60 blur-[1px]" />
                <div className="pointer-events-none absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                    <div className="px-4 py-1 rounded-full bg-white text-black font-heading text-[10px] font-black tracking-[0.25em] uppercase shadow-lg">
                        ★ Le plus populaire
                    </div>
                </div>
            </>
        )}
        {/* Index */}
        <div className="flex items-start justify-between mb-10">
            <div className="font-body text-white/30 text-xs tracking-[0.3em]">
                {String(index).padStart(2, "0")} / FORMULE
            </div>
            {badge && (
                <div className="px-3 py-1 rounded-full bg-white text-black text-[10px] font-heading font-bold tracking-wide uppercase">
                    {badge}
                </div>
            )}
        </div>

        {/* Title */}
        <h3 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter mb-2 text-white">
            {title}
        </h3>

        {/* Price */}
        <div className="flex items-baseline gap-2 mb-3">
            <span
                className="font-heading text-6xl md:text-7xl font-black shine-text"
                data-testid={`${testId}-price`}
            >
                {price}
            </span>
            <span className="font-heading text-3xl text-white/60">€</span>
        </div>

        {duration && (
            <div
                className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/[0.04] border border-white/10 text-white/60 font-body text-[11px] tracking-wide mb-8 md:mb-10"
                data-testid={`${testId}-duration`}
            >
                <Clock className="w-3 h-3" strokeWidth={2} />
                Durée {duration}
            </div>
        )}

        <div className="h-px w-full bg-gradient-to-r from-white/20 via-white/5 to-transparent mb-8" />

        {/* Features */}
        <ul className="space-y-4 mb-8">
            {features.map((f) => (
                <li
                    key={f}
                    className="flex items-start gap-3 font-body text-white/80 text-sm md:text-base leading-relaxed"
                >
                    <span className="mt-1 w-5 h-5 rounded-full bg-white/5 border border-white/10 grid place-items-center flex-shrink-0">
                        <Check
                            className="w-3 h-3 text-white"
                            strokeWidth={3}
                        />
                    </span>
                    {f}
                </li>
            ))}
        </ul>

        {/* Highlighted supplement */}
        {highlight && (
            <div
                className="relative mb-10 rounded-xl border border-white/25 bg-white/[0.07] p-4 md:p-5 overflow-hidden"
                data-testid={`${testId}-highlight`}
            >
                <div className="absolute -top-px left-6 right-6 h-px bg-gradient-to-r from-transparent via-white/60 to-transparent" />
                <div className="flex items-start gap-3">
                    <span className="mt-0.5 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-white text-black text-[10px] font-heading font-bold tracking-wider uppercase whitespace-nowrap">
                        <Sparkles className="w-3 h-3" strokeWidth={2.5} />
                        En +
                    </span>
                    <div className="flex-1">
                        <div className="font-heading text-white text-base md:text-lg font-bold leading-tight">
                            {highlight.title}
                        </div>
                        <div className="font-body text-white/70 text-sm leading-snug mt-1">
                            {highlight.sub}
                        </div>
                    </div>
                </div>
            </div>
        )}

        <a
            href={ctaHref || SMS_BOOKING}
            className={
                featured
                    ? "btn-tactile w-full justify-center"
                    : "btn-tactile-ghost w-full justify-center"
            }
            data-testid={`${testId}-cta`}
        >
            <MessageSquare className="w-4 h-4" strokeWidth={2.2} />
            <span className="font-heading">
                {ctaLabel || "Réserver par SMS"}
            </span>
        </a>
        <div className="mt-3 font-body text-white/40 text-[11px] text-center leading-snug">
            Indiquez prestation, adresse et disponibilités —
            je vous confirme un créneau.
        </div>
    </div>
);

const AutoCompactCard = ({
    index,
    title,
    price,
    badge,
    duration,
    features,
    highlight,
    premium,
    testId,
}) => (
    <div
        data-testid={testId}
        className={`relative rounded-2xl p-5 md:p-6 flex flex-col h-full ${
            premium ? "premium-card" : "crystal overflow-hidden"
        }`}
    >
        {premium && (
            <div className="pointer-events-none absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                <div className="px-3 py-0.5 rounded-full bg-white text-black font-heading text-[9px] font-black tracking-[0.25em] uppercase shadow-lg whitespace-nowrap">
                    ★ Populaire
                </div>
            </div>
        )}
        {badge && !premium && (
            <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-white/10 border border-white/15 text-[9px] font-heading tracking-wider uppercase text-white/80 whitespace-nowrap">
                {badge}
            </span>
        )}

        <div className="font-body text-white/25 text-[10px] tracking-[0.3em] mb-3">
            0{index}
        </div>

        <h3 className="font-heading text-xl md:text-2xl font-bold tracking-tight text-white leading-tight mb-3">
            {title}
        </h3>

        <div className="flex items-end gap-2 mb-4">
            <div className="font-heading text-3xl md:text-4xl font-black text-white tracking-tighter leading-none"
                data-testid={`${testId}-price`}>
                {price}
                <span className="text-xl text-white/50 ml-0.5">€</span>
            </div>
            {duration && (
                <div className="inline-flex items-center gap-1 text-white/50 font-body text-[11px] pb-1">
                    <Clock className="w-3 h-3" strokeWidth={2} />
                    {duration}
                </div>
            )}
        </div>

        <div className="h-px w-full bg-gradient-to-r from-white/20 via-white/5 to-transparent mb-4" />

        <ul className="space-y-2 mb-4 flex-1">
            {features.map((f) => (
                <li
                    key={f}
                    className="flex items-start gap-2 font-body text-white/75 text-[13px] leading-snug"
                >
                    <Check
                        className="w-3 h-3 mt-1 text-white flex-shrink-0"
                        strokeWidth={3}
                    />
                    <span>{f}</span>
                </li>
            ))}
        </ul>

        {highlight && (
            <div
                className="rounded-lg border border-white/20 bg-white/[0.05] p-3 mb-4"
                data-testid={`${testId}-highlight`}
            >
                <div className="flex items-center gap-1.5 mb-1">
                    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-white text-black text-[9px] font-heading font-bold tracking-wider uppercase whitespace-nowrap">
                        <Sparkles className="w-2.5 h-2.5" strokeWidth={2.5} />
                        En +
                    </span>
                    <span className="font-heading text-white text-[13px] font-semibold leading-tight">
                        {highlight.title}
                    </span>
                </div>
                <div className="font-body text-white/60 text-[11px] leading-snug">
                    {highlight.sub}
                </div>
            </div>
        )}

        <a
            href={SMS_BOOKING}
            className="btn-tactile w-full justify-center text-sm py-2.5"
            data-testid={`${testId}-cta`}
        >
            <MessageSquare className="w-3.5 h-3.5" strokeWidth={2.2} />
            <span className="font-heading">Réserver</span>
        </a>
    </div>
);

const Services = () => (
    <Section id="auto" className="relative py-28 md:py-40 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0">
            <img
                src="https://images.pexels.com/photos/31389821/pexels-photo-31389821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Détail intérieur voiture"
                className="w-full h-full object-cover opacity-25"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/80 to-[#050505]" />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
            {/* Header */}
            <div className="grid lg:grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
                <div className="lg:col-span-7">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                        <Car className="w-4 h-4 text-white/50" strokeWidth={1.8} />
                        SERVICE 01 · NETTOYAGE AUTO
                    </div>
                    <h2
                        className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]"
                        data-testid="services-title"
                    >
                        Votre voiture,
                        <br />
                        <span className="text-white/40">
                            comme au premier jour.
                        </span>
                    </h2>
                </div>
                <div className="lg:col-span-5">
                    <p className="font-body text-white/60 text-base md:text-lg leading-relaxed">
                        Quatre formules pour chaque besoin : de l&apos;extérieur
                        express au pack complet intérieur + extérieur avec
                        shampouinage des sièges.
                    </p>
                </div>
            </div>

            {/* Cards grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 items-stretch">
                <AutoCompactCard
                    index={1}
                    title="Extérieur"
                    price="30"
                    duration="≈ 1 h"
                    features={[
                        "Lavage complet de la carrosserie",
                        "Nettoyage des jantes",
                        "Lavage des vitres extérieures",
                        "Séchage à la microfibre",
                    ]}
                    highlight={{
                        title: "+5 € si très sale",
                        sub: "Boue épaisse, résidus tenaces, chantier… uniquement dans ces cas.",
                    }}
                    testId="service-card-ext"
                />
                <AutoCompactCard
                    index={2}
                    title="Intérieur"
                    price="50"
                    duration="≈ 2 h"
                    features={[
                        "Aspiration complète habitacle & coffre",
                        "Dépoussiérage méticuleux",
                        "Nettoyage des plastiques & contours",
                        "Lavage des vitres intérieures",
                    ]}
                    testId="service-card-1"
                />
                <AutoCompactCard
                    index={3}
                    title="Intérieur Complet"
                    price="55"
                    badge="Recommandé"
                    duration="≈ 2 h"
                    features={[
                        "Aspiration complète habitacle & coffre",
                        "Nettoyage plastiques, contours & vitres",
                        "Shampouinage des moquettes & tapis",
                        "Shampouinage des sièges",
                    ]}
                    highlight={{
                        title: "Shampouinage des sièges",
                        sub: "La vraie différence : extraction profonde, taches et odeurs éliminées.",
                    }}
                    testId="service-card-2"
                />
                <AutoCompactCard
                    index={4}
                    title="Pack Ultime"
                    price="80"
                    badge="Pack complet"
                    duration="≈ 3 h"
                    premium
                    features={[
                        "Lavage carrosserie + jantes + vitres ext.",
                        "Séchage à la microfibre",
                        "Aspiration habitacle & coffre",
                        "Nettoyage plastiques & vitres int.",
                        "Shampouinage sièges + moquettes",
                    ]}
                    highlight={{
                        title: "Intérieur + Extérieur · Économie 5 €",
                        sub: "Le meilleur des deux réunis. 85 € en séparé — profitez-en !",
                    }}
                    testId="service-card-pack"
                />
            </div>

            {/* Footnote */}
            <div className="mt-16 md:mt-20 flex flex-wrap items-center gap-6 justify-between border-t border-white/10 pt-8">
                <div className="font-body text-white/40 text-sm flex items-center gap-3">
                    <Sparkles className="w-4 h-4" />
                    Devis personnalisé pour véhicules très sales ou utilitaires.
                </div>
                <a
                    href={PHONE_LINK}
                    className="font-heading text-sm text-white/80 hover:text-white transition-colors flex items-center gap-2"
                    data-testid="services-phone-link"
                >
                    Discutons par téléphone
                    <ArrowUpRight className="w-4 h-4" />
                </a>
            </div>
        </div>
    </Section>
);

const SofaItemCard = ({
    index,
    title,
    price,
    badge,
    illustration,
    description,
    testId,
}) => (
    <div
        data-testid={testId}
        className="crystal rounded-2xl p-5 md:p-6 flex flex-col relative overflow-hidden h-full"
    >
        {badge && (
            <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-white/10 border border-white/15 text-[10px] font-heading tracking-wider uppercase text-white/80">
                {badge}
            </span>
        )}
        <div className="font-body text-white/25 text-[10px] tracking-[0.3em] mb-3">
            0{index}
        </div>
        <div className="text-white/60 mb-4 flex items-end min-h-[64px]">
            {illustration}
        </div>
        <h3 className="font-heading text-xl md:text-2xl font-bold tracking-tight text-white leading-tight mb-1">
            {title}
        </h3>
        <p className="font-body text-white/50 text-xs md:text-sm leading-snug mb-4 flex-1">
            {description}
        </p>
        <div className="flex items-baseline gap-1.5 border-t border-white/10 pt-4">
            <span
                className="font-heading text-3xl md:text-4xl font-black text-white tracking-tighter"
                data-testid={`${testId}-price`}
            >
                {price}
            </span>
            <span className="font-heading text-xl text-white/50">€</span>
        </div>
    </div>
);

const SofaServices = () => (
    <Section
        id="canape"
        className="relative py-28 md:py-40 overflow-hidden bg-[#070708]"
    >
        {/* Background */}
        <div className="absolute inset-0">
            <img
                src="https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=1600&q=80"
                alt="Canapé en tissu"
                className="w-full h-full object-cover opacity-15"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/85 to-[#050505]" />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
                <div className="lg:col-span-7">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                        <Sofa
                            className="w-4 h-4 text-white/50"
                            strokeWidth={1.8}
                        />
                        SERVICE 02 · NETTOYAGE CANAPÉ
                    </div>
                    <h2
                        className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]"
                        data-testid="sofa-title"
                    >
                        Tissus d&apos;ameublement,
                        <br />
                        <span className="text-white/40">
                            ravivés en profondeur.
                        </span>
                    </h2>
                </div>
                <div className="lg:col-span-5">
                    <p className="font-body text-white/60 text-base md:text-lg leading-relaxed">
                        Chaise, fauteuil, canapé 2 places ou plus grand :
                        shampouineuse professionnelle et produits adaptés pour
                        extraire taches, poussières et odeurs.
                    </p>
                </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 items-stretch mb-10">
                <SofaItemCard
                    index={1}
                    title="Chaise"
                    price="10"
                    illustration={<ChairDrawing className="w-14 h-14" />}
                    description="Nettoyage par shampouineuse d'une chaise en tissu."
                    testId="sofa-item-chaise"
                />
                <SofaItemCard
                    index={2}
                    title="Fauteuil"
                    price="20"
                    illustration={<ArmchairDrawing className="w-16 h-16" />}
                    description="Fauteuil 1 place : assise, dossier et accoudoirs."
                    testId="sofa-item-fauteuil"
                />
                <SofaItemCard
                    index={3}
                    title="Canapé 2 places"
                    price="30"
                    illustration={<Sofa2Drawing className="w-20 h-14" />}
                    description="Shampouinage complet d'un canapé 2 places."
                    testId="sofa-item-canape-2"
                />
                <SofaItemCard
                    index={4}
                    title="Tout autre canapé"
                    price="40"
                    badge="Toutes tailles"
                    illustration={<SofaLargeDrawing className="w-24 h-14" />}
                    description="3 places, d'angle, modulable, méridienne."
                    testId="sofa-item-canape-plus"
                />
            </div>

            {/* Common CTA */}
            <div className="flex justify-center">
                <a
                    href={SMS_BOOKING_SOFA}
                    className="btn-tactile"
                    data-testid="sofa-cta"
                >
                    <MessageSquare className="w-4 h-4" strokeWidth={2.2} />
                    <span>Réserver mon nettoyage</span>
                </a>
            </div>

            {/* Material note */}
            <div className="mt-12 md:mt-16 crystal rounded-2xl p-6 md:p-7 flex items-start gap-4 md:gap-5 max-w-3xl">
                <div className="w-11 h-11 rounded-xl bg-white/10 border border-white/15 grid place-items-center flex-shrink-0">
                    <Ban
                        className="w-5 h-5 text-white"
                        strokeWidth={2}
                    />
                </div>
                <div>
                    <div className="font-heading text-white text-base md:text-lg font-semibold mb-1">
                        Tissus uniquement
                    </div>
                    <div className="font-body text-white/60 text-sm md:text-[15px] leading-relaxed">
                        Je n&apos;interviens pas sur les canapés en cuir.
                        Tissu, microfibre, alcantara, velours : pas de
                        problème. Un doute sur votre matière ? Envoyez-moi
                        une photo par SMS.
                    </div>
                </div>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-6 justify-between border-t border-white/10 pt-8">
                <div className="font-body text-white/40 text-sm flex items-center gap-3">
                    <Sparkles className="w-4 h-4" />
                    Frais de déplacement spécifiques au canapé (voir plus bas).
                </div>
                <a
                    href={PHONE_LINK}
                    className="font-heading text-sm text-white/80 hover:text-white transition-colors flex items-center gap-2"
                    data-testid="sofa-phone-link"
                >
                    Discutons par téléphone
                    <ArrowUpRight className="w-4 h-4" />
                </a>
            </div>
        </div>
    </Section>
);

const MAIRIE_COORDS = { lat: 48.9902, lon: 1.7165 };

const CALC_SERVICES = [
    {
        id: "auto-ext",
        type: "auto",
        label: "Auto · Extérieur",
        price: 30,
        sms: SMS_BOOKING,
    },
    {
        id: "auto-int",
        type: "auto",
        label: "Auto · Intérieur",
        price: 50,
        sms: SMS_BOOKING,
    },
    {
        id: "auto-complet",
        type: "auto",
        label: "Auto · Intérieur Complet",
        price: 55,
        sms: SMS_BOOKING,
    },
    {
        id: "pack",
        type: "pack",
        label: "Pack Ultime · Int + Ext",
        price: 80,
        sms: SMS_BOOKING,
    },
    {
        id: "chaise",
        type: "canape",
        label: "Chaise",
        price: 10,
        sms: SMS_BOOKING_SOFA,
    },
    {
        id: "fauteuil",
        type: "canape",
        label: "Fauteuil",
        price: 20,
        sms: SMS_BOOKING_SOFA,
    },
    {
        id: "canape-2",
        type: "canape",
        label: "Canapé 2 places",
        price: 30,
        sms: SMS_BOOKING_SOFA,
    },
    {
        id: "canape-autre",
        type: "canape",
        label: "Autre canapé",
        price: 40,
        sms: SMS_BOOKING_SOFA,
    },
];

const getTravelFee = (km, type = "auto") => {
    if (km == null || km < 0) return null;
    if (type === "canape") {
        if (km <= 10) return { fee: 5, label: "5 €", zone: "0 — 10 km" };
        if (km <= 20) return { fee: 10, label: "10 €", zone: "10 — 20 km" };
        if (km <= 30) return { fee: 15, label: "15 €", zone: "20 — 30 km" };
        if (km <= 40) return { fee: 20, label: "20 €", zone: "30 — 40 km" };
        if (km <= 50) return { fee: 25, label: "25 €", zone: "40 — 50 km" };
        if (km <= 60) return { fee: 30, label: "30 €", zone: "50 — 60 km" };
        return { fee: null, label: "Hors zone", zone: "> 60 km", outOfZone: true };
    }
    if (km <= 10) return { fee: 0, label: "Gratuit", zone: "0 — 10 km" };
    if (km <= 30) return { fee: 10, label: "10 €", zone: "10 — 30 km" };
    if (km <= 50) return { fee: 20, label: "20 €", zone: "30 — 50 km" };
    if (km <= 60) return { fee: 30, label: "30 €", zone: "50 — 60 km" };
    return { fee: null, label: "Hors zone", zone: "> 60 km", outOfZone: true };
};

const PriceCalculator = () => {
    const [query, setQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [showSugg, setShowSugg] = useState(false);
    const [picked, setPicked] = useState(null);
    const [cart, setCart] = useState({}); // { [id]: qty }
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [result, setResult] = useState(null);
    const debounceRef = useRef(null);
    const boxRef = useRef(null);

    // Click outside to close suggestions
    useEffect(() => {
        const onClick = (e) => {
            if (boxRef.current && !boxRef.current.contains(e.target)) {
                setShowSugg(false);
            }
        };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    const fetchSuggestions = (q) => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        if (q.trim().length < 3) {
            setSuggestions([]);
            return;
        }
        debounceRef.current = setTimeout(async () => {
            try {
                const url = `https://nominatim.openstreetmap.org/search?format=json&countrycodes=fr&addressdetails=1&limit=5&q=${encodeURIComponent(
                    q
                )}`;
                const res = await fetch(url, {
                    headers: { "Accept-Language": "fr" },
                });
                const data = await res.json();
                setSuggestions(
                    (data || []).map((d) => ({
                        label: d.display_name,
                        lat: parseFloat(d.lat),
                        lon: parseFloat(d.lon),
                    }))
                );
                setShowSugg(true);
            } catch {
                setSuggestions([]);
            }
        }, 350);
    };

    const onAddressChange = (e) => {
        const v = e.target.value;
        setQuery(v);
        setPicked(null);
        setResult(null);
        fetchSuggestions(v);
    };

    const handlePick = (s) => {
        setPicked(s);
        setQuery(s.label);
        setShowSugg(false);
        setResult(null);
        setError("");
    };

    const addItem = (id) => {
        setCart((c) => ({ ...c, [id]: (c[id] || 0) + 1 }));
        setResult(null);
    };
    const removeItem = (id) => {
        setCart((c) => {
            const q = (c[id] || 0) - 1;
            if (q <= 0) {
                const next = { ...c };
                delete next[id];
                return next;
            }
            return { ...c, [id]: q };
        });
        setResult(null);
    };
    const clearCart = () => {
        setCart({});
        setResult(null);
    };

    const cartEntries = Object.entries(cart)
        .map(([id, qty]) => ({
            service: CALC_SERVICES.find((s) => s.id === id),
            qty,
        }))
        .filter((e) => e.service);

    const subtotal = cartEntries.reduce(
        (sum, { service: s, qty }) => sum + s.price * qty,
        0
    );
    const totalItems = cartEntries.reduce((sum, { qty }) => sum + qty, 0);

    // Travel type: canape only if cart contains ONLY canape items (and has items)
    const hasAnyAuto = cartEntries.some(
        ({ service: s }) => s.type !== "canape"
    );
    const hasAnyCanape = cartEntries.some(
        ({ service: s }) => s.type === "canape"
    );
    const travelType =
        hasAnyCanape && !hasAnyAuto ? "canape" : "auto";

    const compute = async () => {
        setError("");
        setResult(null);
        if (totalItems === 0) {
            setError("Ajoutez au moins une prestation à votre devis.");
            return;
        }
        if (!picked) {
            setError("Sélectionnez une adresse dans la liste.");
            return;
        }
        setLoading(true);
        try {
            const url = `https://router.project-osrm.org/route/v1/driving/${MAIRIE_COORDS.lon},${MAIRIE_COORDS.lat};${picked.lon},${picked.lat}?overview=false`;
            const res = await fetch(url);
            const data = await res.json();
            const meters = data?.routes?.[0]?.distance;
            if (meters == null) throw new Error("no-route");
            const km = meters / 1000;
            const travel = getTravelFee(km, travelType);
            setResult({ km, travel });
        } catch {
            setError("Impossible de calculer la distance. Réessayez.");
        } finally {
            setLoading(false);
        }
    };

    const total =
        result && result.travel && !result.travel.outOfZone
            ? subtotal + result.travel.fee
            : null;

    const resultSms = hasAnyAuto ? SMS_BOOKING : SMS_BOOKING_SOFA;

    const iconFor = (type) =>
        type === "canape" ? Sofa : type === "pack" ? Package : Car;

    return (
        <div
            className="crystal rounded-2xl p-6 md:p-10 lg:p-12 mt-16 md:mt-20 relative overflow-hidden"
            data-testid="price-calculator"
        >
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-white/[0.03] blur-3xl pointer-events-none" />

            <div className="relative grid lg:grid-cols-12 gap-10">
                {/* Left: inputs */}
                <div className="lg:col-span-7">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-5 flex items-center gap-3">
                        <Calculator
                            className="w-4 h-4 text-white/60"
                            strokeWidth={1.8}
                        />
                        CALCULATEUR DE PRIX
                    </div>
                    <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold tracking-tighter leading-[1] mb-3">
                        Composez votre devis
                        <br />
                        <span className="text-white/40">
                            en quelques clics.
                        </span>
                    </h3>
                    <p className="font-body text-white/60 text-sm md:text-base leading-relaxed mb-8">
                        Ajoutez une ou plusieurs prestations, saisissez votre
                        adresse : le total s&apos;adapte avec les bons frais de
                        déplacement.
                    </p>

                    {/* Address input */}
                    <label className="block font-body text-white/50 text-[11px] tracking-[0.2em] uppercase mb-2">
                        Votre adresse
                    </label>
                    <div className="relative mb-6" ref={boxRef}>
                        <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-white/[0.04] border border-white/15 focus-within:border-white/40 transition-colors">
                            <Search
                                className="w-4 h-4 text-white/40"
                                strokeWidth={2}
                            />
                            <input
                                type="text"
                                value={query}
                                onChange={onAddressChange}
                                onFocus={() =>
                                    suggestions.length && setShowSugg(true)
                                }
                                placeholder="12 rue Exemple, 78711 Mantes-la-Ville"
                                className="bg-transparent flex-1 outline-none text-white placeholder:text-white/30 font-body text-sm md:text-base"
                                data-testid="calc-address-input"
                            />
                        </div>
                        {showSugg && suggestions.length > 0 && (
                            <div
                                className="absolute z-30 mt-2 w-full max-h-72 overflow-auto rounded-xl border border-white/15 bg-[#0d0d10]/95 backdrop-blur-xl shadow-2xl"
                                data-testid="calc-suggestions"
                            >
                                {suggestions.map((s, i) => (
                                    <button
                                        key={i}
                                        type="button"
                                        onClick={() => handlePick(s)}
                                        className="w-full text-left px-4 py-3 text-sm text-white/80 hover:bg-white/[0.06] font-body border-b border-white/5 last:border-0 flex items-start gap-2"
                                        data-testid={`calc-suggestion-${i}`}
                                    >
                                        <MapPin
                                            className="w-3.5 h-3.5 text-white/40 mt-0.5 flex-shrink-0"
                                            strokeWidth={2}
                                        />
                                        <span className="leading-snug">
                                            {s.label}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Service picker */}
                    <div className="flex items-center justify-between mb-2">
                        <label className="block font-body text-white/50 text-[11px] tracking-[0.2em] uppercase">
                            Vos prestations · ajoutez-en plusieurs
                        </label>
                        {totalItems > 0 && (
                            <button
                                type="button"
                                onClick={clearCart}
                                data-testid="calc-clear"
                                className="font-body text-white/40 hover:text-white text-[11px] uppercase tracking-wider transition-colors"
                            >
                                Vider
                            </button>
                        )}
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-8">
                        {CALC_SERVICES.map((s) => {
                            const Icon = iconFor(s.type);
                            const qty = cart[s.id] || 0;
                            const active = qty > 0;
                            return (
                                <div
                                    key={s.id}
                                    data-testid={`calc-service-${s.id}`}
                                    className={`rounded-xl border px-3.5 py-3 transition-all flex items-center gap-3 ${
                                        active
                                            ? "border-white/60 bg-white/[0.08]"
                                            : "border-white/15 bg-white/[0.03] hover:border-white/30"
                                    }`}
                                >
                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-1.5 mb-0.5">
                                            <Icon
                                                className="w-3.5 h-3.5 text-white/70 flex-shrink-0"
                                                strokeWidth={2}
                                            />
                                            <span className="font-heading text-[13px] leading-tight text-white truncate">
                                                {s.label}
                                            </span>
                                        </div>
                                        <div className="font-heading text-sm font-bold text-white">
                                            {s.price} €
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-1.5 flex-shrink-0">
                                        <button
                                            type="button"
                                            onClick={() => removeItem(s.id)}
                                            disabled={qty === 0}
                                            data-testid={`calc-dec-${s.id}`}
                                            className={`w-7 h-7 rounded-full border grid place-items-center transition-colors ${
                                                qty === 0
                                                    ? "bg-white/[0.02] border-white/5 text-white/20 cursor-not-allowed"
                                                    : "bg-white/10 border-white/15 text-white hover:bg-white/20"
                                            }`}
                                        >
                                            <span className="text-base leading-none">
                                                −
                                            </span>
                                        </button>
                                        <span
                                            data-testid={`calc-qty-${s.id}`}
                                            className={`font-heading text-sm font-bold w-5 text-center ${
                                                active
                                                    ? "text-white"
                                                    : "text-white/30"
                                            }`}
                                        >
                                            {qty}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => addItem(s.id)}
                                            data-testid={`calc-inc-${s.id}`}
                                            className="w-7 h-7 rounded-full bg-white text-black grid place-items-center hover:bg-white/90 transition-colors"
                                        >
                                            <span className="text-base leading-none">
                                                +
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <button
                        type="button"
                        onClick={compute}
                        disabled={loading || !picked || totalItems === 0}
                        data-testid="calc-compute-btn"
                        className="btn-tactile justify-center w-full md:w-auto disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:transform-none disabled:hover:shadow-none disabled:hover:bg-white"
                    >
                        {loading ? (
                            <Loader2
                                className="w-4 h-4 animate-spin"
                                strokeWidth={2.4}
                            />
                        ) : (
                            <Calculator
                                className="w-4 h-4"
                                strokeWidth={2.4}
                            />
                        )}
                        <span>
                            {loading
                                ? "Calcul en cours…"
                                : "Calculer mon devis"}
                        </span>
                    </button>

                    {error && (
                        <div
                            className="mt-4 text-sm font-body text-red-300 flex items-center gap-2"
                            data-testid="calc-error"
                        >
                            <Info className="w-4 h-4" />
                            {error}
                        </div>
                    )}
                </div>

                {/* Right: cart & result */}
                <div className="lg:col-span-5">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-5 flex items-center gap-3">
                        <span className="w-8 h-px bg-white/30" />
                        VOTRE DEVIS
                    </div>

                    <div
                        className="rounded-2xl border border-white/15 bg-white/[0.04] p-6 md:p-7"
                        data-testid="calc-cart"
                    >
                        {totalItems === 0 ? (
                            <div
                                className="text-center py-6"
                                data-testid="calc-empty"
                            >
                                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-white/5 border border-white/10 grid place-items-center">
                                    <Calculator
                                        className="w-5 h-5 text-white/40"
                                        strokeWidth={1.8}
                                    />
                                </div>
                                <div className="font-heading text-white/70 text-sm">
                                    Ajoutez au moins une prestation pour
                                    commencer.
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className="space-y-2.5 mb-5 pb-5 border-b border-white/10">
                                    {cartEntries.map(({ service: s, qty }) => {
                                        const Icon = iconFor(s.type);
                                        return (
                                            <div
                                                key={s.id}
                                                data-testid={`calc-line-${s.id}`}
                                                className="flex items-center justify-between gap-3 font-body text-sm"
                                            >
                                                <div className="flex items-center gap-2 min-w-0 flex-1">
                                                    <Icon
                                                        className="w-3.5 h-3.5 text-white/50 flex-shrink-0"
                                                        strokeWidth={2}
                                                    />
                                                    <span className="text-white/85 truncate">
                                                        {s.label}
                                                    </span>
                                                    <span className="text-white/40 text-xs flex-shrink-0">
                                                        × {qty}
                                                    </span>
                                                </div>
                                                <span className="text-white font-heading flex-shrink-0">
                                                    {s.price * qty} €
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="flex items-center justify-between font-body text-sm mb-3">
                                    <span className="text-white/60">
                                        Sous-total prestations
                                    </span>
                                    <span
                                        className="text-white font-heading"
                                        data-testid="calc-subtotal"
                                    >
                                        {subtotal} €
                                    </span>
                                </div>

                                {result && (
                                    <>
                                        <div className="flex items-center justify-between font-body text-sm mb-3">
                                            <span className="text-white/60">
                                                Déplacement
                                                <span className="text-white/30 text-xs ml-2">
                                                    {result.km.toFixed(1)} km
                                                    · {result.travel.zone}
                                                </span>
                                            </span>
                                            <span
                                                className="text-white font-heading"
                                                data-testid="calc-travel-fee"
                                            >
                                                {result.travel.outOfZone
                                                    ? "—"
                                                    : result.travel.fee === 0
                                                      ? "Gratuit"
                                                      : `${result.travel.fee} €`}
                                            </span>
                                        </div>

                                        {result.travel.outOfZone ? (
                                            <div className="rounded-xl bg-amber-400/10 border border-amber-400/30 p-4 mt-5 mb-5">
                                                <div className="font-heading text-amber-200 text-sm font-semibold mb-1">
                                                    Au-delà de 60 km
                                                </div>
                                                <div className="font-body text-amber-100/80 text-xs leading-snug">
                                                    Envoyez-moi un SMS pour un
                                                    devis personnalisé.
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex items-end justify-between border-t border-white/10 pt-5 mb-5 mt-2">
                                                <div className="font-body text-white/60 text-xs uppercase tracking-wider">
                                                    Total à payer
                                                </div>
                                                <div
                                                    className="font-heading text-4xl md:text-5xl font-black shine-text leading-none"
                                                    data-testid="calc-total"
                                                >
                                                    {total} €
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {!result && (
                                    <div className="mt-3 font-body text-white/40 text-[11px] leading-snug">
                                        Entrez votre adresse puis cliquez sur
                                        « Calculer mon devis » pour afficher
                                        les frais de déplacement et le total.
                                    </div>
                                )}

                                {result && (
                                    <>
                                        <a
                                            href={resultSms}
                                            className="btn-tactile w-full justify-center"
                                            data-testid="calc-book-cta"
                                        >
                                            <MessageSquare
                                                className="w-4 h-4"
                                                strokeWidth={2.2}
                                            />
                                            <span>Réserver par SMS</span>
                                        </a>
                                        <div className="mt-4 font-body text-white/40 text-[11px] leading-snug text-center">
                                            Estimation indicative basée sur la
                                            distance routière depuis la mairie
                                            de Mantes-la-Jolie.
                                        </div>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const TravelFees = () => {
    const [mode, setMode] = useState("auto");
    const zonesAuto = [
        {
            range: "0 — 10 km",
            price: "Gratuit",
            sub: "Mantes-la-Jolie & proche",
            color: "from-emerald-400/30 to-emerald-400/0",
            dot: "bg-emerald-400",
            testId: "fee-auto-1",
        },
        {
            range: "10 — 30 km",
            price: "10 €",
            sub: "Agglomération mantoise",
            color: "from-sky-400/30 to-sky-400/0",
            dot: "bg-sky-400",
            testId: "fee-auto-2",
        },
        {
            range: "30 — 50 km",
            price: "20 €",
            sub: "Yvelines élargies",
            color: "from-amber-400/30 to-amber-400/0",
            dot: "bg-amber-400",
            testId: "fee-auto-3",
        },
        {
            range: "50 — 60 km",
            price: "30 €",
            sub: "Paris & Val-d'Oise",
            color: "from-rose-400/30 to-rose-400/0",
            dot: "bg-rose-400",
            testId: "fee-auto-4",
        },
    ];
    const zonesCanape = [
        {
            range: "0 — 10 km",
            price: "5 €",
            sub: "Mantes-la-Jolie & proche",
            color: "from-emerald-400/30 to-emerald-400/0",
            dot: "bg-emerald-400",
            testId: "fee-canape-1",
        },
        {
            range: "10 — 20 km",
            price: "10 €",
            sub: "Agglomération mantoise",
            color: "from-teal-400/30 to-teal-400/0",
            dot: "bg-teal-400",
            testId: "fee-canape-2",
        },
        {
            range: "20 — 30 km",
            price: "15 €",
            sub: "Autour de l'agglomération",
            color: "from-sky-400/30 to-sky-400/0",
            dot: "bg-sky-400",
            testId: "fee-canape-3",
        },
        {
            range: "30 — 40 km",
            price: "20 €",
            sub: "Yvelines élargies",
            color: "from-amber-400/30 to-amber-400/0",
            dot: "bg-amber-400",
            testId: "fee-canape-4",
        },
        {
            range: "40 — 50 km",
            price: "25 €",
            sub: "Zone étendue",
            color: "from-orange-400/30 to-orange-400/0",
            dot: "bg-orange-400",
            testId: "fee-canape-5",
        },
        {
            range: "50 — 60 km",
            price: "30 €",
            sub: "Paris & Val-d'Oise",
            color: "from-rose-400/30 to-rose-400/0",
            dot: "bg-rose-400",
            testId: "fee-canape-6",
        },
    ];
    const zones = mode === "auto" ? zonesAuto : zonesCanape;

    return (
        <Section
            id="deplacement"
            className="relative py-24 md:py-32 bg-[#0a0a0c] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    {/* Left: text + zones */}
                    <div className="lg:col-span-6">
                        <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                            <span className="w-8 h-px bg-white/30" />
                            FRAIS DE DÉPLACEMENT
                        </div>
                        <h2
                            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] mb-6"
                            data-testid="travel-title"
                        >
                            Je me déplace
                            <br />
                            <span className="text-white/40">
                                jusqu&apos;à chez vous.
                            </span>
                        </h2>
                        <p className="font-body text-white/60 leading-relaxed mb-8 max-w-lg">
                            Tarif transparent au kilomètre depuis Mantes-la-Jolie.
                            Deux grilles distinctes selon la prestation.
                        </p>

                        {/* Toggle */}
                        <div
                            className="inline-flex items-center gap-1 p-1 rounded-full bg-white/[0.04] border border-white/10 mb-8"
                            data-testid="travel-toggle"
                        >
                            <button
                                type="button"
                                onClick={() => setMode("auto")}
                                data-testid="travel-toggle-auto"
                                className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full font-heading text-xs md:text-sm transition-all ${
                                    mode === "auto"
                                        ? "bg-white text-black"
                                        : "text-white/60 hover:text-white"
                                }`}
                            >
                                <Car className="w-3.5 h-3.5" strokeWidth={2} />
                                Auto
                            </button>
                            <button
                                type="button"
                                onClick={() => setMode("canape")}
                                data-testid="travel-toggle-canape"
                                className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full font-heading text-xs md:text-sm transition-all ${
                                    mode === "canape"
                                        ? "bg-white text-black"
                                        : "text-white/60 hover:text-white"
                                }`}
                            >
                                <Sofa
                                    className="w-3.5 h-3.5"
                                    strokeWidth={2}
                                />
                                Canapé
                            </button>
                        </div>

                        <div className="space-y-3">
                            {zones.map((z) => (
                                <div
                                    key={z.range}
                                    data-testid={z.testId}
                                    className="crystal rounded-xl p-4 md:p-5 flex items-center gap-5 relative overflow-hidden"
                                >
                                    <div
                                        className={`absolute inset-0 bg-gradient-to-r ${z.color} opacity-60 pointer-events-none`}
                                    />
                                    <span
                                        className={`relative w-3 h-3 rounded-full ${z.dot} shadow-[0_0_20px_currentColor]`}
                                    />
                                    <div className="relative flex-1 flex items-baseline justify-between gap-4 flex-wrap">
                                        <div>
                                            <div className="font-heading text-white text-base md:text-lg font-semibold">
                                                {z.range}
                                            </div>
                                            <div className="font-body text-white/50 text-xs">
                                                {z.sub}
                                            </div>
                                        </div>
                                        <div className="font-heading text-2xl md:text-3xl font-black text-white tracking-tighter">
                                            {z.price}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-10 space-y-4">
                            <div className="flex items-center gap-3 font-body text-white/40 text-sm">
                                <Navigation
                                    className="w-4 h-4"
                                    strokeWidth={1.8}
                                />
                                Au-delà de 60 km, contactez-moi pour un devis.
                            </div>
                            <a
                                href={SMS_LINK}
                                data-testid="travel-sms-cta"
                                className="crystal rounded-xl p-5 flex items-center gap-4 hover:border-white/25 transition-all group"
                            >
                                <div className="w-11 h-11 rounded-full bg-white text-black grid place-items-center flex-shrink-0">
                                    <MessageSquare
                                        className="w-5 h-5"
                                        strokeWidth={2.2}
                                    />
                                </div>
                                <div className="flex-1">
                                    <div className="font-heading text-white text-sm md:text-base font-semibold">
                                        Carte peu lisible ?
                                    </div>
                                    <div className="font-body text-white/50 text-xs md:text-sm leading-snug mt-0.5">
                                        Envoyez-moi un SMS avec la prestation
                                        souhaitée + votre adresse, je vous
                                        réponds avec le tarif exact.
                                    </div>
                                </div>
                                <ArrowUpRight className="w-5 h-5 text-white/60 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </a>
                        </div>
                    </div>

                    {/* Right: map image */}
                    <div className="lg:col-span-6">
                        <div className="crystal rounded-2xl overflow-hidden relative">
                            <div className="absolute top-4 left-4 z-10 flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/60 backdrop-blur-md border border-white/10 text-xs font-body text-white/80">
                                <MapPin
                                    className="w-3 h-3"
                                    strokeWidth={2}
                                />
                                Centré sur Mantes-la-Jolie
                            </div>
                            <img
                                src="https://customer-assets.emergentagent.com/job_nettoyage-auto-1/artifacts/852i5y91_Image%2005-06-2026%20a%CC%80%2014.20.JPG"
                                alt="Carte des zones de déplacement autour de Mantes-la-Jolie"
                                className="w-full h-auto block"
                                data-testid="travel-map"
                            />
                            <div className="absolute inset-0 ring-1 ring-inset ring-white/10 pointer-events-none rounded-2xl" />
                        </div>
                    </div>
                </div>

                <PriceCalculator />
            </div>
        </Section>
    );
};

const TikTokSection = () => (
    <Section
        id="avant-apres"
        className="relative py-24 md:py-32 overflow-hidden bg-[#050505]"
    >
        <div
            className="absolute inset-0 opacity-20 pointer-events-none"
            style={{
                backgroundImage:
                    "radial-gradient(circle at 20% 30%, rgba(255,0,80,0.15), transparent 50%), radial-gradient(circle at 80% 70%, rgba(0,200,255,0.12), transparent 50%)",
            }}
        />
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
            <div className="grid lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                        <span className="w-8 h-px bg-white/30" />
                        AVANT / APRÈS · RÉSEAUX
                    </div>
                    <h2
                        className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] mb-6"
                        data-testid="tiktok-title"
                    >
                        Voyez la
                        <br />
                        <span className="text-white/40">
                            transformation.
                        </span>
                    </h2>
                    <p className="font-body text-white/60 leading-relaxed text-base md:text-lg max-w-xl mb-10">
                        Retrouvez toutes les vidéos avant / après de mes
                        prestations sur TikTok et Instagram. Sièges
                        shampouinés, moquettes ressuscitées, habitacles
                        métamorphosés.
                    </p>
                    <div className="flex flex-wrap items-center gap-3">
                        <a
                            href={TIKTOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-tactile group"
                            data-testid="tiktok-cta"
                        >
                            <Play
                                className="w-4 h-4 fill-current"
                                strokeWidth={2.4}
                            />
                            <span>@{TIKTOK_HANDLE}</span>
                            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-tactile-ghost group"
                            data-testid="instagram-cta"
                        >
                            <Instagram
                                className="w-4 h-4"
                                strokeWidth={2}
                            />
                            <span className="font-heading">
                                @{INSTAGRAM_HANDLE}
                            </span>
                            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                        </a>
                    </div>
                </div>

                {/* Phone frame mockup */}
                <div className="lg:col-span-5">
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="tiktok-phone-frame"
                        className="block relative mx-auto max-w-[280px] aspect-[9/19] rounded-[2.5rem] border border-white/15 bg-[#0a0a0c] p-3 shadow-[0_30px_80px_rgba(0,0,0,0.6)] transition-transform hover:scale-[1.02] hover:rotate-1"
                    >
                        <div className="relative w-full h-full rounded-[2rem] overflow-hidden bg-black">
                            <img
                                src="https://images.pexels.com/photos/31389821/pexels-photo-31389821.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                                alt="Aperçu vidéo avant/après"
                                className="w-full h-full object-cover opacity-90"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80" />
                            <div className="absolute top-4 left-4 right-4 flex items-center justify-between text-[10px] font-body text-white/70 uppercase tracking-wider">
                                <span>Pour Toi</span>
                                <span className="opacity-60">Abonnements</span>
                            </div>
                            <div className="absolute inset-0 grid place-items-center">
                                <div className="w-16 h-16 rounded-full bg-white/95 grid place-items-center shadow-2xl">
                                    <Play
                                        className="w-7 h-7 text-black ml-1 fill-current"
                                    />
                                </div>
                            </div>
                            <div className="absolute bottom-4 left-4 right-4">
                                <div className="font-heading text-white text-sm font-bold mb-1">
                                    @{TIKTOK_HANDLE}
                                </div>
                                <div className="font-body text-white/70 text-xs leading-snug">
                                    Avant/Après nettoyage intérieur 🔥
                                </div>
                            </div>
                        </div>
                        {/* Notch */}
                        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-24 h-6 bg-[#050505] rounded-b-2xl" />
                    </a>
                </div>
            </div>
        </div>
    </Section>
);

const Testimonials = () => {
    const reviews = [
        {
            name: "Sophie M.",
            city: "Mantes-la-Jolie",
            rating: 5,
            text: "Travail impeccable sur ma voiture familiale. Les sièges étaient catastrophiques après 2 ans avec les enfants, on dirait du neuf. Très professionnel.",
        },
        {
            name: "Karim B.",
            city: "Limay",
            rating: 5,
            text: "Service au top, ponctuel et tarif honnête. La formule intérieur complet vaut vraiment le coup, la moquette n'a plus aucune odeur.",
        },
        {
            name: "Élodie R.",
            city: "Magnanville",
            rating: 5,
            text: "Je le recommande les yeux fermés. Soin du détail, écoute des besoins et résultat bluffant. Je le rappellerai sans hésiter.",
        },
    ];
    return (
        <Section
            id="avis"
            className="relative py-24 md:py-32 bg-[#050505] overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-wrap items-end justify-between gap-6 mb-14 md:mb-20">
                    <div>
                        <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                            <span className="w-8 h-px bg-white/30" />
                            ILS PARLENT DE MOI
                        </div>
                        <h2
                            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]"
                            data-testid="testimonials-title"
                        >
                            La confiance,
                            <br />
                            <span className="text-white/40">
                                ça se prouve.
                            </span>
                        </h2>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="flex">
                            {[...Array(5)].map((_, i) => (
                                <Star
                                    key={i}
                                    className="w-5 h-5 text-white fill-white"
                                />
                            ))}
                        </div>
                        <div className="font-body text-white/60 text-sm">
                            5,0 · clients satisfaits
                        </div>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-6">
                    {reviews.map((r, i) => (
                        <div
                            key={r.name}
                            data-testid={`testimonial-${i + 1}`}
                            className="crystal rounded-2xl p-7 md:p-8 relative flex flex-col"
                        >
                            <Quote
                                className="w-8 h-8 text-white/15 mb-5"
                                strokeWidth={1.5}
                            />
                            <p className="font-body text-white/85 leading-relaxed mb-6 flex-1 text-[15px]">
                                &ldquo;{r.text}&rdquo;
                            </p>
                            <div className="flex items-center justify-between border-t border-white/10 pt-5">
                                <div>
                                    <div className="font-heading text-white text-sm font-semibold">
                                        {r.name}
                                    </div>
                                    <div className="font-body text-white/40 text-xs flex items-center gap-1 mt-0.5">
                                        <MapPin className="w-3 h-3" />
                                        {r.city}
                                    </div>
                                </div>
                                <div className="flex gap-0.5">
                                    {[...Array(r.rating)].map((_, idx) => (
                                        <Star
                                            key={idx}
                                            className="w-3.5 h-3.5 text-white fill-white"
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 flex items-center justify-center gap-2 font-body text-white/40 text-xs">
                    <Car className="w-3.5 h-3.5" />
                    Avis vérifiables — demandez les contacts par téléphone.
                </div>
            </div>
        </Section>
    );
};

const PracticalInfo = () => {
    const items = [
        {
            icon: Plug,
            title: "Une prise électrique",
            sub: "Indispensable",
            text: "Le matériel pro (shampouineuse, aspirateur) nécessite une prise. Je dispose d'une rallonge de 20 m pour atteindre la plupart des stationnements.",
            badge: "20 m de rallonge fournie",
            testId: "info-electricity",
        },
        {
            icon: Waves,
            title: "Un point d'eau",
            sub: "Nettoyage extérieur",
            text: "Pour toute prestation extérieure (Extérieur seul ou Pack Ultime), un accès à un robinet est requis. Je branche mon tuyau et je m'occupe du reste.",
            badge: "Robinet accessible",
            testId: "info-water",
        },
        {
            icon: CloudRain,
            title: "Service sous la pluie",
            sub: "Tout temps",
            text: "Un barnum 3 m × 3 m me permet de travailler à l'abri. Pensez simplement à prévoir l'espace nécessaire pour son installation.",
            badge: "Barnum 3 m × 3 m",
            testId: "info-rain",
        },
        {
            icon: Info,
            title: "Un doute sur le tarif ?",
            sub: "Devis SMS",
            text: "Envoyez-moi un message avec la prestation souhaitée et votre adresse complète. Je vous confirme le prix total (déplacement inclus) en quelques minutes.",
            badge: "Réponse rapide par SMS",
            cta: { href: SMS_LINK, label: "Envoyer un SMS" },
            testId: "info-quote",
        },
    ];

    return (
        <Section
            id="infos"
            className="relative py-24 md:py-32 bg-[#050505] overflow-hidden"
        >
            <div
                className="absolute inset-0 opacity-30 pointer-events-none"
                style={{
                    backgroundImage:
                        "linear-gradient(135deg, rgba(255,255,255,0.04) 0%, transparent 60%)",
                }}
            />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
                    <div className="lg:col-span-7">
                        <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                            <span className="w-8 h-px bg-white/30" />
                            BON À SAVOIR
                        </div>
                        <h2
                            className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95]"
                            data-testid="info-title"
                        >
                            Avant ma venue,
                            <br />
                            <span className="text-white/40">
                                quatre petites choses.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5">
                        <p className="font-body text-white/60 text-base md:text-lg leading-relaxed">
                            Pour que tout se passe parfaitement le jour J,
                            voici ce qu&apos;il faut prévoir.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {items.map((it, idx) => (
                        <div
                            key={it.title}
                            data-testid={it.testId}
                            className="crystal rounded-2xl p-7 flex flex-col relative overflow-hidden"
                        >
                            <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-white/[0.03] blur-2xl pointer-events-none" />

                            <div className="flex items-start justify-between mb-8">
                                <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 grid place-items-center">
                                    <it.icon
                                        className="w-5 h-5 text-white"
                                        strokeWidth={1.8}
                                    />
                                </div>
                                <span className="font-body text-white/30 text-[10px] tracking-[0.25em]">
                                    0{idx + 1}
                                </span>
                            </div>

                            <div className="font-body text-white/40 text-xs tracking-[0.2em] uppercase mb-2">
                                {it.sub}
                            </div>
                            <h3 className="font-heading text-2xl md:text-[28px] font-bold tracking-tighter text-white mb-4 leading-tight">
                                {it.title}
                            </h3>
                            <p className="font-body text-white/65 text-sm leading-relaxed flex-1 mb-6">
                                {it.text}
                            </p>

                            <div className="border-t border-white/10 pt-5 flex items-center justify-between gap-3">
                                <div className="flex items-center gap-2 font-body text-xs text-white/70">
                                    <Check
                                        className="w-3.5 h-3.5"
                                        strokeWidth={2.6}
                                    />
                                    {it.badge}
                                </div>
                                {it.cta && (
                                    <a
                                        href={it.cta.href}
                                        className="text-xs font-heading text-white hover:opacity-80 flex items-center gap-1 whitespace-nowrap"
                                        data-testid={`${it.testId}-cta`}
                                    >
                                        {it.cta.label}
                                        <ArrowUpRight className="w-3.5 h-3.5" />
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Section>
    );
};

const Zone = () => (
    <Section id="zone" className="relative py-24 md:py-32 bg-[#0a0a0c]">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
            <div className="grid md:grid-cols-12 gap-10 items-center">
                <div className="md:col-span-5">
                    <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-6 flex items-center gap-3">
                        <span className="w-8 h-px bg-white/30" />
                        ZONE D&apos;INTERVENTION
                    </div>
                    <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tighter leading-[0.95] mb-6">
                        Mantes‑la‑Jolie
                        <br />
                        <span className="text-white/40">et alentours.</span>
                    </h2>
                    <p className="font-body text-white/60 leading-relaxed">
                        Basé dans le 78, je me déplace dans toute
                        l&apos;agglomération de Mantes et les communes voisines.
                        Contactez‑moi pour vérifier la disponibilité dans votre
                        secteur.
                    </p>
                </div>

                <div className="md:col-span-7">
                    <div className="crystal rounded-2xl p-8 md:p-10 grid grid-cols-2 sm:grid-cols-3 gap-y-5 gap-x-4">
                        {[
                            "Mantes-la-Jolie",
                            "Mantes-la-Ville",
                            "Limay",
                            "Buchelay",
                            "Magnanville",
                            "Rosny-sur-Seine",
                            "Épône",
                            "Gargenville",
                            "Issou",
                        ].map((c) => (
                            <div
                                key={c}
                                className="flex items-center gap-2 font-body text-white/80 text-sm"
                            >
                                <MapPin
                                    className="w-3.5 h-3.5 text-white/40"
                                    strokeWidth={2}
                                />
                                {c}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </Section>
);

const Contact = () => (
    <Section id="contact" className="relative py-28 md:py-40 overflow-hidden">
        <div className="absolute inset-0">
            <img
                src="https://images.unsplash.com/photo-1550565076-b2371ea1a324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx3YXRlciUyMGRyb3BsZXRzJTIwb24lMjBkYXJrJTIwY2FyJTIwcGFpbnR8ZW58MHx8fHwxNzgwNjc0OTY2fDA&ixlib=rb-4.1.0&q=85"
                alt="Gouttes d'eau sur peinture noire"
                className="w-full h-full object-cover opacity-30"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/85 to-[#050505]/70" />
        </div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-12 text-center md:text-left">
            <div className="font-body text-white/40 text-xs tracking-[0.3em] mb-8 flex items-center gap-3 justify-center md:justify-start">
                <span className="w-8 h-px bg-white/30" />
                RÉSERVATION
                <span className="w-8 h-px bg-white/30" />
            </div>

            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.92] mb-8 max-w-4xl">
                Réservez votre
                <br />
                <span className="text-white/40">créneau.</span>
            </h2>

            <p className="font-body text-white/60 text-lg max-w-2xl mb-12 mx-auto md:mx-0">
                Un seul numéro. Une réponse rapide. Un devis honnête.
                <br className="hidden md:block" />
                Disponible 7j/7 de 9h à 19h.
            </p>

            <a
                href={PHONE_LINK}
                className="group inline-block"
                data-testid="footer-phone-link"
            >
                <div className="font-heading text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black tracking-tighter leading-none transition-all">
                    <span className="shine-text">{PHONE_DISPLAY}</span>
                </div>
                <div className="mt-6 font-body text-white/40 text-sm tracking-[0.2em] flex items-center gap-2 justify-center md:justify-start uppercase">
                    <Phone className="w-3.5 h-3.5" strokeWidth={2.4} />
                    Appel direct · 7j/7 · 9h — 19h
                </div>
            </a>

            <div className="mt-16 flex flex-wrap gap-4 justify-center md:justify-start">
                <a
                    href={SMS_BOOKING}
                    className="btn-tactile"
                    data-testid="contact-sms-cta"
                >
                    <MessageSquare className="w-4 h-4" strokeWidth={2.4} />
                    <span>Prendre rendez-vous</span>
                </a>
                <a
                    href={PHONE_LINK}
                    className="btn-tactile-ghost"
                    data-testid="contact-call-cta"
                >
                    <Phone className="w-4 h-4" strokeWidth={2} />
                    <span className="font-heading">Appeler directement</span>
                </a>
                <a
                    href={EMAIL_LINK}
                    className="btn-tactile-ghost"
                    data-testid="contact-email-cta"
                >
                    <Mail className="w-4 h-4" strokeWidth={2} />
                    <span className="font-heading">{EMAIL}</span>
                </a>
            </div>
            <div className="mt-6 font-body text-white/40 text-xs md:text-sm max-w-2xl mx-auto md:mx-0 leading-relaxed">
                Pour prendre rendez-vous (auto ou canapé) : envoyez-moi un SMS
                avec la <span className="text-white/70">prestation souhaitée</span>,
                votre <span className="text-white/70">adresse complète</span>{" "}
                et vos <span className="text-white/70">disponibilités</span>.
                Je vous confirme un créneau ou je vous propose un autre moment.
            </div>
        </div>
    </Section>
);

const Footer = () => (
    <footer className="border-t border-white/10 bg-[#050505] py-10 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-between gap-4 text-xs font-body text-white/40">
            <div className="flex items-center gap-3">
                <div className="w-7 h-7 rounded-full bg-white text-black grid place-items-center font-heading font-black text-sm">
                    É
                </div>
                <span className="font-heading text-white/70 tracking-tight">
                    ÉCLAT
                </span>
                <span className="hidden md:inline">
                    · Nettoyage auto & canapé
                </span>
            </div>
            <div className="flex items-center gap-6 flex-wrap">
                <a
                    href={EMAIL_LINK}
                    className="hover:text-white transition-colors flex items-center gap-1.5"
                    data-testid="footer-email"
                >
                    <Mail className="w-3.5 h-3.5" />
                    {EMAIL}
                </a>
                <a
                    href={TIKTOK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors"
                    data-testid="footer-tiktok"
                >
                    TikTok · @{TIKTOK_HANDLE}
                </a>
                <a
                    href={INSTAGRAM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors flex items-center gap-1.5"
                    data-testid="footer-instagram"
                >
                    <Instagram className="w-3.5 h-3.5" />
                    @{INSTAGRAM_HANDLE}
                </a>
                <a
                    href={PHONE_LINK}
                    className="hover:text-white transition-colors"
                    data-testid="footer-phone-text"
                >
                    {PHONE_DISPLAY}
                </a>
                <span className="hidden md:inline">{LOCATION}</span>
                <span>© {new Date().getFullYear()}</span>
            </div>
        </div>
    </footer>
);

const StickyCallBar = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        window.addEventListener("scroll", onScroll);
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    return (
        <a
            href={PHONE_LINK}
            data-testid="sticky-call-bar"
            className={`md:hidden fixed bottom-4 left-4 right-4 z-40 transition-all duration-500 ${
                show
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-8 pointer-events-none"
            }`}
        >
            <div className="btn-tactile w-full justify-center shadow-2xl">
                <Phone className="w-4 h-4" strokeWidth={2.4} />
                <span>Appeler · {PHONE_DISPLAY}</span>
            </div>
        </a>
    );
};

export default function Landing() {
    return (
        <main
            className="relative bg-[#050505] text-white"
            data-testid="landing-page"
        >
            <Nav />
            <Hero />
            <Marquee />
            <Services />
            <SofaServices />
            <TravelFees />
            <PracticalInfo />
            <TikTokSection />
            <Testimonials />
            <Contact />
            <Footer />
            <StickyCallBar />
        </main>
    );
}
